import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { getServerTime } from 'services/dashboard.service';

// Hora do servidor, lida uma vez por montagem da Home e avançada por um único relógio de 1 s,
// compartilhado por `TaskCycles` e `TaskCyclesEcoa` (DCE-35, DCE-36). Fica restrito às seções que
// o consomem para não re-renderizar a Home inteira a cada segundo.

const ServerClockContext = createContext(0);

interface ServerClockProviderProps {
  /** Só lê a hora quando alguma seção que a usa está visível. */
  enabled: boolean;
  children: ReactNode;
}

export function ServerClockProvider({ enabled, children }: ServerClockProviderProps) {
  const [now, setNow] = useState(0);

  useEffect(() => {
    if (!enabled) return;

    let active = true;
    let interval: number | undefined;

    getServerTime()
      .then(timestamp => {
        if (!active) return;

        setNow(timestamp);
        interval = window.setInterval(() => setNow(previous => previous + 1000), 1000);
      })
      // Sem hora, as seções seguem como hoje: 0 significa "ainda sem hora".
      .catch(() => undefined);

    return () => {
      active = false;
      window.clearInterval(interval);
    };
  }, [enabled]);

  return <ServerClockContext.Provider value={now}>{children}</ServerClockContext.Provider>;
}

/** Hora do servidor em ms; 0 até a primeira leitura chegar. */
export function useServerNow(): number {
  return useContext(ServerClockContext);
}
